import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteItem, loadPaymentRequest } from "../../../../../../../../../../../store/Concept/actions";
import { contributorData } from "../../../../../../../../../../../store/Users/selectors";
import DeleteIcon from "../../../../../../../../../../commons/Icons/DeleteIcon";
import { Wrapper } from "./styled";
import { getInternalId, getParam } from "../../../../../../../../../../../utils/functions";
import { getPaymentSummary, loadInternalId } from "../../../../../../../../../../../store/Concept/actions";

const DeleteButton = ({ id }) => {
  const dispatch = useDispatch();
  const [param, setParam] = useState(null);
  const contributor = useSelector(contributorData);

  const removeItem = () => {
    dispatch(loadPaymentRequest(null));
    dispatch(loadInternalId(getInternalId(contributor)));
    dispatch(deleteItem(id));
  };

  useEffect(() => {
    dispatch(loadInternalId(getInternalId(contributor)));
    setParam(getParam("id"));
  }, []);

  useEffect(() => {
    if (param !== null) {
      dispatch(getPaymentSummary(param));
    }
  }, param);

  if (param !== null) {
    return null;
  }

  return (
    <Wrapper onClick={() => dispatch(removeItem())}>
      <DeleteIcon />
    </Wrapper>
  );
};

export default DeleteButton;
